import { observer } from 'mobx-react-lite'
import { ContentError } from '@/components/ContentError'
import { type EditRefundDialogViewModel } from '@/features/jobs/info-gathering/tax-refund-method/components/EditRefundDialog/EditRefundDialogViewModel'
import { type TaxRefundMethodViewModel } from '@/features/jobs/info-gathering/tax-refund-method/TaxRefundMethodViewModel'
import { RefundInfo } from '@/features/jobs/info-gathering/tax-refund-method/components/RefundInfo'

export interface RefundInfoContainerProps {
  vm: TaxRefundMethodViewModel
  editVm: EditRefundDialogViewModel | null
}

export const RefundInfoContainer = observer(function RefundInfoContainer({
  vm,
  editVm,
}: RefundInfoContainerProps) {
  if (!vm.isRelevant && !editVm) {
    return null
  }

  const renderRefundInfo = (isLoading: boolean) => (
    <RefundInfo
      isBothEmpty={vm.isBothEmpty}
      isLoading={isLoading}
      isEditable={!!editVm?.canShow}
      hasPersonalSupportingItem={!!vm.personalRefundMethodSupportingItem}
      hasBusinessSupportingItem={!!vm.businessRefundMethodSupportingItem}
      isPersonalRefundMethodProvided={
        !!vm.personalRefundMethodSupportingItem?.completed
      }
      isBusinessRefundMethodProvided={
        !!vm.businessRefundMethodSupportingItem?.completed
      }
      personalRefundMethod={vm.personalRefundMethodDisplay}
      businessRefundMethod={vm.businessRefundMethodDisplay}
      onEditPersonal={editVm?.showPersonal}
      onEditBusiness={editVm?.showBusiness}
      emptyStateActionTestId="refund-empty-state-action"
      personalEditButtonTestId="update-personal-refund-button"
      personalEmptyStateActionTestId="personal-refund-empty-state-action"
      businessEditButtonTestId="update-business-refund-button"
      businessEmptyStateActionTestId="business-refund-empty-state-action"
    />
  )

  return vm.fetch.match({
    pending: () => renderRefundInfo(true),
    rejected: (err) => <ContentError error={err} />,
    resolved: () => renderRefundInfo(false),
  })
})
